<template>
  <div class="fasciaBoard">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>参展</BreadcrumbItem>
          <BreadcrumbItem>楣板信息</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibition/index/exinfo/fascia-alter');">
          <span>返回</span>
        </div>
      </div>
    </div>

    <div class="fasciaBoard-content">
      <Form
        ref="formInline"
        :model="formInline"
        :rules="ruleInline"
        label-position="right"
        :label-width="120"
        @submit.native.prevent
      >
        <FormItem label="展区：">
          <Input style="width:580px;" type="text" v-model="formInline.exArea" disabled />
        </FormItem>
        <FormItem label="展位号：">
          <Input style="width:580px;" type="text" v-model="formInline.exHall" disabled />
        </FormItem>
        <FormItem label="公司中文名：" prop="comName">
          <Input style="width:580px;" type="text" v-model="formInline.comName" />
        </FormItem>
        <FormItem label="公司英文名：" prop="comNameEn">
          <Input style="width:580px;" type="text" v-model="formInline.comNameEn" />
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="handleSubmit('formInline')"
            style="width: 154px;height:36px;"
            :loading="loading"
          >保存</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validator";
import config from "@assets/config.json";

export default {
  name: "exhibition-info-fasciaBoard",
  data() {
    return {
      formInline: {
        exArea: "", // 展区
        exHall: "", // 展位号
        comName: "", // 公司中文名
        comNameEn: "" // 公司英文名
      },
      ruleInline: {
        comName: [
          { required: true, message: "请输入公司中文名", trigger: "blur" }
        ],
        comNameEn: [
          { required: true, message: "请输入公司英文名", trigger: "blur" }
        ]
      },
      loading: false,
      fasciaBoardIsHave: false,
      fasciaBoardInfo: null,
      fasciaBoardDownInfo: null
    };
  },
  computed: {
    ...mapGetters({
      joinInfo: "loginModule/getJoinInfo",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    exhibitionId() {
      return this.exhibition.id;
    }
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 楣板信息";
    this.init();
  },
  methods: {
    ...mapActions({
      getFasciaBoardDown: "exhibitionModule/getFasciaBoardDown",
      editFasciaBoardDown: "exhibitionModule/editFasciaBoardDown",
    }),
    async init() {
      // if (this.joinInfo && this.joinInfo.boothInfo) {
      //   let boothInfo = JSON.parse(this.joinInfo.boothInfo);
      //   this.formInline.exArea = this.joinInfo.exArea;
      //   for (let i = 0; i < boothInfo.length; i++) {
      //     if (boothInfo.length > 1) {
      //       this.formInline.exHall +=
      //         boothInfo[i].Hall + "-" + boothInfo[i].Code + "、";
      //     } else {
      //       this.formInline.exHall +=
      //         boothInfo[i].Hall + "-" + boothInfo[i].Code;
      //     }
      //   }
      // }
      if (this.joinInfo && this.joinInfo.exArea) {
        this.formInline.exArea = this.joinInfo.exArea;
      }
      if (this.joinInfo && this.joinInfo.boothInfo && this.joinInfo.boothInfo.length) {
        if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object String]') {
          if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
            this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
          }
        }
        if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object Object]') {
          if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
            this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
          }
          if (this.joinInfo.boothInfo.Hall) {
            this.formInline.exHall = this.joinInfo.boothInfo.Hall + "-" + this.joinInfo.boothInfo.Code;
          } else {
            this.formInline.exHall = this.joinInfo.boothInfo.Code;
          }
        }
        if (Object.prototype.toString.call(this.joinInfo.boothInfo) === '[object Array]') {
          let boothInfo = this.joinInfo.boothInfo;
          for (let i = 0; i < boothInfo.length; i++) {
            if (boothInfo.length > 1) {
              if (boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall + "-" + boothInfo[i].Code + "、";
              }
              if (boothInfo[i].Hall && !boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall + "、";
              }
              if (!boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Code + "、";
              }
              
            } else {
              if (boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall + "-" + boothInfo[i].Code;
              }
              if (boothInfo[i].Hall && !boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall;
              }
              if (!boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Code;
              }

            }
          }
        }
        // this.formInline.exHall = boothInfo.Hall + '-' + boothInfo.Code;
      }

      // 获取楣板修改记录
      let result = await this.getFasciaBoardDown(this.joinInfo.joinId);
      if (result) {
        this.fasciaBoardDownInfo = result;
        this.formInline.comName = result.compName;
        this.formInline.comNameEn = result.compNameEn;
        console.log("fasciaBoardDownInfo：",this.fasciaBoardDownInfo)
      }
    },
    async handleSubmit(name) {
      let valid = await this.validForm(name);
      if (!valid) return;

      let req = {
        CompName: this.formInline.comName,
        CompNameEn: this.formInline.comNameEn
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let opt = {
        Id: this.fasciaBoardDownInfo.id,
        SetValues: req
      };
      let result = await this.editFasciaBoardDown(opt);
      if (result && result.successed) {
        this.$Message.success("保存成功，请等待审核");
        this.$router.push("/exhibition/index/exinfo/fascia-alter");
      } else {
        this.$Message.warning(`保存失败，请重试`);
      }
      setTimeout(() => {
        this.loading = false;
      },1000);
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.fasciaBoard {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 800px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
  }
}
</style>
